/**
 * @file ドロワーメニュー開閉
 *
 */
'use strict';

/**
 * @classname ShowPassport
 * @classdesc ドロワーメニュー開閉
 */
export default class ShowPassport {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ShowPassport.constructor');
		this._$e = $e;
		
		const passportFirst = JSON.parse(localStorage.getItem('passport')) || null;
		const passportList = JSON.parse(localStorage.getItem('passportList')) || null;
		if(passportFirst){
			
			let passport = passportFirst;
			
			if (passportList && passportList.length > 1) {
				passport = passportList[0];
			} 
			if(passport['child_name']){
				$('.text--passport-name').text(passport['child_name']);
			}else{
				$('.text--passport-name').text('未設定');
			}
			$('.text--passport-year').text(passport['child_birthday_yy']);
			$('.text--passport-month').text(passport['child_birthday_mm']);
			$('.text--passport-day').text(passport['child_birthday_dd']);
		}else{
			location.href ='/';
		}
	};
}
